import { useState } from "react";
import { message } from "antd";
import { edit_company } from "../../../services";

export const useSaveClassifications = (
	token,
	data,
	updateData,
	pendingOperations,
	clearPendingOperations,
	setBackupData,
	cleanupData
) => {
	const [loading, setLoading] = useState(false);

	const saveChanges = async (companyId) => {
		if (pendingOperations.length === 0) {
			message.info("No hay cambios para guardar");
			return;
		}

		try {
			setLoading(true);

			// Preparar los datos para enviar al backend
			const operations = pendingOperations.map((op) => ({
				type: op.type,
				ids: op.ids,
				data: op.data,
			}));

			// Llamada al servicio
			const res = await edit_company(
				token,
				{
					companyId,
					operations,
				},
				"classifications"
			);

			if (!res) {
				message.error("Error al guardar las clasificaciones");
				return;
			}

			// Si todo salió bien, actualizar el backup y limpiar operaciones
			const updatedData = cleanupData(data, pendingOperations);
			setBackupData(updatedData);
			updateData(updatedData);
			clearPendingOperations();
			message.success("Clasificaciones guardadas correctamente");
		} catch (error) {
			console.error(error);
			message.error(
				error.response?.data || "Error al guardar las clasificaciones"
			);
		} finally {
			setLoading(false);
		}
	};

	return {
		loading,
		setLoading,
		saveChanges,
	};
};
